import React, { Component } from "react";
import { connect } from "react-redux";
import "./styles.scss";
import "./mobile.scss";
import uuid from "react-uuid";
import * as actionTypes from "../../../store/actions/types";
import moment from "moment";
import { Button, Input } from "../../../components";
import { GetIcon } from "../../../config/icon";
import Scrollbars from "react-custom-scrollbars";
import { RiCheckLine, RiCloseLine } from "react-icons/ri";
import { updateOfferStatus } from "../../../api";

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      wizardNo: 1,
      registeredType: 1,
      viewPointWidth: 0,
      viewPointHeight: 0,
      wizardStep: 1,
      isLoading: false,
      dataForm: {
        rejectReason: {
          key: "rejectReason",
          elementType: "select",
          elementConfig: {
            type: "text",
            placeholder: "Please select reject reason",
            options: [
              { id: uuid(), value: "Not clear image", isActive: false },
              { id: uuid(), value: "Less details", isActive: false },
              { id: uuid(), value: "Invalid data", isActive: false },
            ],
            disabled: false,
          },
          value: "",
          defaultValue: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "Reject reason",
        },
        comment: {
          key: "comment",
          elementType: "input",
          elementConfig: {
            type: "text",
            placeholder: "",
          },
          value: "",
          validation: {
            required: false,
          },
          valid: false,
          touched: false,
          label: "Comment",
        },
      },
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
  }

  handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    console.log("scrollTop : " + scrollTop);
    console.log("scrollHeight : " + scrollHeight);
    console.log("clientHeight :" + clientHeight);
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("scroll", this.handleOnScroll);
    // this.props.getAllRecentTransfers();
    //this.props.getAllFavouritesTransfers();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  onClickReject = async () => {
    let selectOffer = this.props.selectedOffer;
    if (selectOffer && selectOffer.offerId) {
      let { dataForm } = this.state;

      this.setState({ isLoading: true });

      let body = {
        reason: dataForm.rejectReason.value,
        comment: dataForm.comment.value,
        status: "rejected",
      };

      let res = await updateOfferStatus(body, selectOffer.offerId);

      if (res && res.data && res.data.status) {
        this.setState({ isLoading: false });
        this.props.refreshOffers();
        this.props.closeRejectOfferModal();
        this.props.closeOfferViewModal();
      }
    } else {
      return false;
    }
  };

  //=== Check form validation
  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = value.trim() !== "" && isValid;
    }
    return isValid;
  }

  updateFormValidity = (inputIdentity) => {
    const updateSignUpForm = this.state.dataForm;
    const updatedFormElement = updateSignUpForm[inputIdentity];
    console.log(updatedFormElement);
    // updatedFormElement.value = event.target.value;
    updatedFormElement.valid = this.checkValidity(
      updatedFormElement.value,
      updatedFormElement.validation
    );
    updatedFormElement.touched = true;
    updateSignUpForm[inputIdentity] = updatedFormElement;
    this.setState({ dataForm: updateSignUpForm });
  };

  //==== Input Handle Change
  inputHandleChange = (event, inputIdentity) => {
    console.log(event, inputIdentity);
    const updateForm = {
      ...this.state.dataForm,
    };
    const updatedFormElement = {
      ...updateForm[inputIdentity],
    };

    updatedFormElement.value = event.target.value;
    updatedFormElement.valid = this.checkValidity(
      updatedFormElement.value,
      updatedFormElement.validation
    );
    updatedFormElement.touched = true;
    updateForm[inputIdentity] = updatedFormElement;
    let formIsValid = true;
    for (let inputIdentifier in updateForm) {
      formIsValid = updateForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({ dataForm: updateForm, formIsValid: formIsValid });
  };

  render() {
    const { isOfferReject } = this.props;
    const { viewPointHeight, dataForm, isrejectReasonLoading, isLoading } =
      this.state;

    return (
      <section
        className={`coo__modal-main-wrapper animate__animated ${
          isOfferReject ? "show-me" : "hide-me"
        } `}
      >
        <div
          className={"coo_modal-body-content fix-536 d-flex flex-column"}
          style={{
            top: "30%",
            padding: "24px",
            borderRadius: "32px",
          }}
        >
          <div
            className={
              "d-flex flex-row justify-content-between align-content-center align-items-center"
            }
          >
            <div className={"coo_mbc__reject-header"}>{"Offer reject"}</div>
            <div
              className={`close-modal-wrapper `}
              style={{ position: "inherit" }}
              onClick={() => {
                this.props.closeRejectOfferModal();
              }}
            >
              <RiCloseLine />
            </div>
          </div>
          {/* <Scrollbars
            style={{ height: viewPointHeight - 480 }}
            thumbMinSize={30}
            universal={true}
            autoHide
          > */}
          <div className={"coo_modal-content-wrapper d-flex flex-column"}>
            <div style={{ marginTop: "24px", marginBottom: "32px" }}>
              <Input
                elementConfig={dataForm.rejectReason.elementConfig}
                elementType={dataForm.rejectReason.elementType}
                required={dataForm.rejectReason.validation.required}
                isValid={!dataForm.rejectReason.valid}
                touched={dataForm.rejectReason.touched}
                value={dataForm.rejectReason.value}
                defaultValue={dataForm.rejectReason.defaultValue}
                isLoading={isrejectReasonLoading}
                isShowRequired={true}
                size={"md"}
                margin={""}
                label={dataForm.rejectReason.label}
                // onKeyPress={this.handleKeyPress.bind(this)}
                changed={(e) => {
                  const updateForm = { ...this.state.dataForm };
                  updateForm["rejectReason"].value = e;
                  this.setState({ dataForm: updateForm });
                  // this.inputHandleChange(e, dataForm.rejectReason.key);
                }}
              />
            </div>
            <Input
              elementConfig={dataForm.comment.elementConfig}
              elementType={dataForm.comment.elementType}
              required={dataForm.comment.validation.required}
              isinvalid={!dataForm.comment.valid}
              touched={dataForm.comment.touched}
              value={dataForm.comment.value}
              isShowRequired={false}
              size={"md"}
              margin={""}
              label={dataForm.comment.label}
              changed={(event) =>
                this.inputHandleChange(event, dataForm.comment.key)
              }
            />
          </div>
          {/* </Scrollbars> */}
          <div style={{ marginTop: "24px" }}>
            <Button
              leftIconFill={true}
              iconName={<RiCheckLine />}
              leftIcon={false}
              rightIcon={false}
              option={"mb-2"}
              isLoading={isLoading}
              isActiveAnimation={false}
              reactRightIcon={GetIcon("")}
              onClick={async () => {
                await this.onClickReject();
              }}
              LeftIconText={"Done"}
              text={""}
              size={"md"}
              type={"btn-block"}
            />
            <Button
              leftIcon={false}
              rightIcon={false}
              option={""}
              isLoading={false}
              isActiveAnimation={false}
              reactRightIcon={GetIcon("leftArrow")}
              onClick={() => {
                this.props.closeRejectOfferModal();
              }}
              text={"Cancel"}
              size={"md"}
              type={"btn-block-back"}
            />
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOfferReject: state.rejectReducer.isOfferReject,
    selectedOffer: state.offerReducer.selectedOffer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeRejectOfferModal: () =>
      dispatch({ type: actionTypes.CLOSE_OFFER_REJECT_MODAL, status: false }),
    closeOfferViewModal: () =>
      dispatch({ type: actionTypes.CLOSE_OFFER_VIEW_MODAL, status: false }),
    refreshOffers: () =>
      dispatch({
        type: actionTypes.REFRESH_OFFERS_LIST,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
